import { render, staticRenderFns } from "./WMenuItems.vue?vue&type=template&id=e9f9097e&"
import script from "./WMenuItems.vue?vue&type=script&lang=js&"
export * from "./WMenuItems.vue?vue&type=script&lang=js&"
import style0 from "./WMenuItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports